import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled } from '../../theme/utils.js';
import '../../theme/types.js';
import { getOverrides } from '../../overrides.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledLoaderWrapper = styled("span", () => ({
  display: "inline-flex"
}));
const getCommonDotStyles = ($theme, size) => ({
  borderColor: "inherit",
  height: `${size}px`,
  width: `${size}px`,
  borderRadius: "50%",
  borderStyle: "solid",
  borderWidth: "2px",
  content: '""',
  display: "inline-block",
  animationDuration: "1.5s",
  animationIterationCount: "infinite",
  animationTimingFunction: $theme.animation.timingFn.easeIn
});
const DotCenter = styled("span", ({ $theme, size }) => __spreadProps(__spreadValues({}, getCommonDotStyles($theme, size)), {
  borderWidth: `${size * 0.38}px`,
  animationName: {
    "0%, 25%": {
      transform: "scale(1)"
    },
    "50%": {
      transform: "scale(0.5)"
    },
    "75%, 100%": {
      transform: "scale(1)"
    }
  }
}));
const DotLeft = styled("span", ({ $theme, size }) => __spreadProps(__spreadValues({}, getCommonDotStyles($theme, size)), {
  marginRight: `${size * 0.25}px`,
  borderWidth: `${size * 0.16}px`,
  animationName: {
    "0%": {
      transform: "scale(1)"
    },
    "25%": {
      transform: "scale(0.5)"
    },
    "50%, 100%": {
      transform: "scale(1)"
    }
  }
}));
const DotRight = styled("span", ({ $theme, size }) => __spreadProps(__spreadValues({}, getCommonDotStyles($theme, size)), {
  marginLeft: `${size * 0.25}px`,
  borderWidth: `${size * 0.3}px`,
  animationName: {
    "0%, 50%": {
      transform: "scale(1)"
    },
    "75%": {
      transform: "scale(0.5)"
    },
    "100%": {
      transform: "scale(1)"
    }
  }
}));
const DEFAULT_SIZE = 30;
const DotsLoader = (_a) => {
  var _b = _a, { size = DEFAULT_SIZE, overrides } = _b, props = __objRest(_b, ["size", "overrides"]);
  const [Root, rootProps] = getOverrides(overrides == null ? void 0 : overrides.Root, StyledLoaderWrapper);
  const dotProps = { size };
  return jsxs(Root, __spreadProps(__spreadValues(__spreadValues({}, rootProps), props), { children: [jsx(DotLeft, __spreadValues({}, dotProps)), jsx(DotCenter, __spreadValues({}, dotProps)), jsx(DotRight, __spreadValues({}, dotProps))] }));
};

export { DotsLoader };
